<template>
  <div>
    <v-simple-table
      fixed-header
    >
      <template v-slot:default>
        <thead>
        <tr>
          <th class="text-left">
            Nome
          </th>
          <th class="text-left">
            Descrição
          </th>
          <th class="text-left">
            IP Público
          </th>
          <th class="text-left">
            Estado
          </th>
          <th class="text-left">
            Zona
          </th>
          <th class="text-left">
            Configurações
          </th>
          <th class="text-left">
          </th>
        </tr>
        </thead>
        <tbody>
        <tr
          v-for="machine in machines"
          :key="machine.id"
        >
          <td>{{ machine.name }}</td>
          <td>{{ machine.description }}</td>
          <td>{{ machine.externalIp }}</td>
          <td>{{ machine.status }} <small>{{ machine.statusMessage }}</small></td>
          <td>{{ machine.zone }}</td>
          <td>
            <strong>Tipo:</strong> {{ machine.machineType }}
            <strong>Disco:</strong> {{ machine.disks }}
            <strong>Rede:</strong> {{ machine.networks }}
          </td>
          <td>
            <v-btn text :disabled="!canStart(machine)" @click="start(machine)" color="success">
              <v-icon left>mdi-play</v-icon>
              Iniciar
            </v-btn>
            <v-btn text :disabled="!canStop(machine)" @click="stop(machine)" color="error">
              <v-icon left>mdi-stop</v-icon>
              Parar
            </v-btn>
            <v-btn text :disabled="!canReset(machine)" @click="reset(machine)" color="error">
              <v-icon left>mdi-restart</v-icon>
              Reiniciar
            </v-btn>
            <v-btn text @click="status(machine)" color="primary">
              <v-icon left>mdi-reload</v-icon>
              Atualizar estado
            </v-btn>
            <v-btn text @click="ip(machine)" color="primary">
              <v-icon left>mdi-ip</v-icon>
              Atualizar IP
            </v-btn>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-alert v-if="!machines.length" type="info">
      Nenhuma máquina encontrada na GCP.
    </v-alert>
    <v-dialog v-model="loading" persistent fullscreen>
      <v-container fluid fill-height style="background-color: rgba(255, 255, 255, 0.5);">
        <v-layout justify-center align-center>
          <v-progress-circular
            indeterminate
            color="#00aab0"
            :size="100"
            :width="10"
          >
          </v-progress-circular>
        </v-layout>
      </v-container>
    </v-dialog>
    <v-snackbar v-model="snackbar">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>

import GcpService from '@/services/gcp/gcp.service';

const gcpService = new GcpService();

export default {
  name: 'GcpMachines',
  data: () => ({
    machines: [],
    loading: false,
    snackbar: false,
    snackbarText: '',
  }),
  mounted() {
    this.loadMachines();
  },
  methods: {
    showSnack(text) {
      this.snackbar = true;
      this.snackbarText = text;
    },
    loadMachines() {
      this.loading = true;

      gcpService.getInstances()
        .then((response) => {
          this.machines = response.data;
        })
        .catch(console.error)
        .finally(() => this.loading = false);
    },
    canStart(machine) {
      return machine.status === 'TERMINATED';
    },
    canStop(machine) {
      return machine.status === 'RUNNING';
    },
    canReset(machine) {
      return machine.status === 'RUNNING';
    },
    start(machine) {
      this.loading = true;

      const zone = machine.zone.split('/').pop();

      gcpService.start(machine.name, zone)
        .then((response) => {
          this.showSnack(response.data.message);
          this.status(machine);
          this.ip(machine);
        })
        .catch(console.error)
        .finally(() => this.loading = false);
    },
    stop(machine) {
      this.loading = true;

      const zone = machine.zone.split('/').pop();

      gcpService.stop(machine.name, zone)
        .then((response) => {
          this.showSnack(response.data.message);
          this.status(machine);
        })
        .catch(console.error)
        .finally(() => this.loading = false);
    },
    reset(machine) {
      this.loading = true;

      const zone = machine.zone.split('/').pop();

      gcpService.reset(machine.name, zone)
        .then((response) => {
          this.showSnack(response.data.message);
          this.status(machine);
          this.ip(machine);
        })
        .catch(console.error)
        .finally(() => this.loading = false);
    },
    status(machine) {
      this.loading = true;

      const zone = machine.zone.split('/').pop();

      gcpService.status(machine.name, zone)
        .then((response) => {
          machine.status = response.data.status;
        })
        .catch(console.error)
        .finally(() => this.loading = false);
    },
    ip(machine) {
      this.loading = true;

      const zone = machine.zone.split('/').pop();

      gcpService.ip(machine.name, zone)
        .then((response) => {
          machine.externalIp = response.data.externalIp;
        })
        .catch(console.error)
        .finally(() => this.loading = false);
    },
  },
};
</script>

<style scoped>

</style>
